import React from "react";
import { useNavigate } from "react-router-dom";
import { RouteItemData } from "../../types";

interface RouteListProps {
  routes: RouteItemData[];
}

const RouteList: React.FC<RouteListProps> = ({ routes }) => {
  const navigate = useNavigate();

  if (!routes || routes.length === 0) {
    return <p>No routes available.</p>;
  }

  return (
    <div className="mx-auto w-full max-w-7xl">
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <table className="w-full border-collapse table-fixed text-sm">
          <thead className="bg-blue-600 text-white">
            <tr>
              <th className="w-6 p-3 text-left"></th>
              <th className="p-3 text-left">Route Name</th>
              <th className="p-3 text-left">Start: City, State</th>
              <th className="p-3 text-left">End: City, State</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {routes.map((route) => (
              <tr
                key={route.id}
                onClick={() => navigate(`/route/details/${route.id}`)}
                className="hover:bg-gray-100 transition-colors duration-200 cursor-pointer"
              >
                <td className="p-3">
                  <div
                    style={{ backgroundColor: route.color }}
                    className="w-4 h-4 rounded-full"
                  ></div>
                </td>
                <td className="p-3">{route.name ? route.name : route.id}</td>
                <td className="p-3">
                  {`${route.start_loc.city}, ${route.start_loc.state}`}
                </td>
                <td className="p-3">
                  {`${route.end_loc.city}, ${route.end_loc.state}`}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RouteList;
